import React from 'react';
import { i18n } from '@lt/localization';
import MultichoiceFilterGroup from '../components/MultichoiceFilterGroup';

import type { IFilter } from '../types';

const FilterMeals = ({
  className = '',
  isMobile = false,
  ...props
}: IFilter): JSX.Element => (
  <MultichoiceFilterGroup
    className={className}
    isMobile={isMobile}
    {...props}
    Filter={FilterMeals}
    expandLabel={i18n.t('filters.meals.show')}
    visibleItems={5}
  />
);

export default Object.assign(FilterMeals, {
  filterName: 'meals',
  filterLabel: i18n.t('filters.meals.title'),
});
